import { LobbyImage } from '@colonist/types';
import { createDivIn, createImgIn, createLinkIn, createParagraphIn, setElementInnerText, setElementOnClick } from '../../../shared/scripts/ui_utils/DomUtils.ts';
import { NotificationContentType } from '../../../shared/scripts/ui_utils/NotificationUtils.ts';
export class UICornerNotificationView {
    get isPermanent() {
        return this._isPermanent;
    }
    resetTimerAnimation(duration) {
        if (this.timerContainer == undefined) return;
        this.notification.removeChild(this.timerContainer);
        this.createTimerAnimation(duration);
    }
    createTimerAnimation(duration) {
        this.timerContainer = createDivIn(this.notification, 'corner-notification-timer-bg');
        const horizontalTimerFill = createDivIn(this.timerContainer, 'corner-notification-timer-fill');
        horizontalTimerFill.style.animation = `widthToZero ${duration}ms linear forwards`;
    }
    close() {
        if (this.notification.parentElement == undefined) return;
        if (this.removeAction != undefined) this.removeAction();
        this.notification.classList.add('fade-out');
        this.notification.addEventListener('transitionend', ()=>{
            if (this.notification.parentElement !== this.container) return;
            this.container.removeChild(this.notification);
        }, {
            once: true
        });
    }
    updateText(newText) {
        setElementInnerText(this.text, newText);
    }
    updateRemoveAction(removeAction) {
        this.removeAction = removeAction;
    }
    static createNotificationTextElement(container, text, action) {
        const isTextLink = action !== undefined;
        if (!isTextLink) return createParagraphIn(container, text, '');
        const linkElement = createLinkIn(container, '#', text, '');
        setElementOnClick(linkElement, ()=>action(), true);
        return linkElement;
    }
    constructor(icon, text, duration, action, removeAction, isPermanent = false, contentType = NotificationContentType.General){
        this.container = document.getElementById('corner-notification-container');
        this.notification = createDivIn(this.container, 'corner-notification');
        createImgIn(this.notification, icon, 'corner-notification-image');
        this.contentContainer = createDivIn(this.notification, 'corner-notification-content-container');
        this.text = UICornerNotificationView.createNotificationTextElement(this.contentContainer, text, action);
        this.crossImage = createImgIn(this.contentContainer, LobbyImage.XMark, 'corner-notification-cross');
        if (!isPermanent) this.createTimerAnimation(duration);
        this.notification.classList.add('slide-in');
        this.removeAction = removeAction;
        this._isPermanent = isPermanent;
        this.contentType = contentType;
        setElementOnClick(this.crossImage, ()=>this.close());
    }
}
